import './tripStrap.css';

import { useEffect, useState } from 'react';

import Calendar from '../../assets/icons/trvto_calendar.svg';
import CancelBooking from './tripStrapFun/cancelBooking';
import { ReactComponent as Close } from '../../assets/icons/trvto_close.svg';
import { ReactComponent as Delete } from '../../assets/icons/trvto_deleteIcon.svg';
import { useNavigate } from 'react-router-dom';
import RateTrip from '../ratingTrip/rateTrip';
import ReviewStars from '../reviewStars/ReviewStars';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import UserCount from '../../assets/icons/trvto_userCount.svg';
import { getAmenities } from './tripStrapFun/amenities';
import { handleBooking } from './tripStrapFun/handleBooking';
import image1 from '../../assets/images/trvto_tripDetails.jpg';
import { share } from './tripStrapFun/shareFun';
import { userReview } from '../../api/userAPI';
import RenderFormContent from './renderFormContent';
import TableContent from './tableContent';
import { handleWishlistClick } from '../../utils/wishlistHandler';
import { calculateOfferPrice, getHikedPrice } from '../../utils/getAmountWithTransaction';
import { isTripDateMoreThanNumOfDays } from '../../utils/date';
import { standardDate } from '../../utils/formatDate';
import { getRefundAmount } from './amountRefundFun/amountRefund';
import { parsePurify } from '../../utils/parsePurify';
import RescheduleBooking from './tripStrapFun/RescheduleBooking';
import { truncateText } from '../../utils/maskFields';
import { toast } from 'react-toastify';

export default function TripStrap({ page, data, userWishlist, setUserWishlist, setRefetch }) {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showBookingInfo, setShowBookingInfo] = useState(false);
    const [typeSel, setTypeSel] = useState('trip');
    const [userRating, setUserRating] = useState(0);
    const [isRatingEnabled, setIsRatingEnabled] = useState(false);
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [comment, setComment] = useState('');
    const [showOverlay, setShowOverlay] = useState(false);
    const [newCardData, setNewCardData] = useState({});
    const [refundAmount, setRefundAmount] = useState(0);
    const [popupRating, setPopupRating] = useState(userRating);
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [isTripMoreThanTenDays, setIsTripMoreThanTenDays] = useState(false);
    const [isTripMoreThanOneDays, setIsTripMoreThanOneDays] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const width = window.innerWidth;
    const createdAt = data.createdAt;
    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);

    useEffect(() => {
        const today = new Date();
        const startDate = new Date(data?.startDate);
        today.setHours(0, 0, 0, 0);
        if (startDate <= today) {
            setIsRatingEnabled(true);
        }
    }, [data?.startDate]);

    useEffect(() => {
        if (!createdAt) return;

        const createdTime = new Date(createdAt);
        const expiryTime = new Date(createdTime.getTime() + 6 * 60 * 60 * 1000); // +6 hours
        const now = new Date();

        if (now < expiryTime) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [createdAt]);

    //eslint-disable-next-line
    const handleCancelBooking = async (e) => {
        e.stopPropagation();
        const refundAmount = await getRefundAmount({ amount: data?.amountPaid?.paid, startDate: data?.startDate });
        setRefundAmount(refundAmount);
        setShowModal(true);
    };

    const handleRescheduleBooking = (event) => {
        event.stopPropagation();
        setShowRescheduleModal(true);
    };

    const openRatingModal = (e, cardData) => {
        e.stopPropagation();
        setShowRatingModal(true);
        setPopupRating(userRating);
        setNewCardData(cardData);
    };

    const closeRatingModal = () => {
        setShowRatingModal(false);
    };

    const handleClick = (data) => {
        navigate(`/trip/details/${data}`, {
            state: { tripStatus }
        });
    };

    const handleInfoClick = () => {
        if (page === 'bookings') {
            setShowBookingInfo(!showBookingInfo);
        } else {
            setShowOverlay(!showOverlay);
        }
    };

    const handleSubmitRating = async (e) => {
        e.preventDefault();

        const ratingData = {
            packId: newCardData?._id,
            userName: localStorage.getItem('name') || '',
            userId: localStorage.getItem('userId') || '',
            rating: popupRating,
            organizerId: data?.organizerId,
            comment
        };

        try {
            await userReview(typeSel, ratingData);
            toast.success('Thank you! Your rating has been submitted');
            setUserRating(popupRating);
            closeRatingModal();
        } catch (error) {
            console.error('Error submitting rating:', error);
        }
    };

    let cardData;
    let packStartDate;
    let packEndDate;
    let pickUpLocation;
    let startCity;
    let tripStatus;
    let paymentInfoStatus;

    if (page === 'bookings') {
        cardData = data?.packId;
        packStartDate = data?.startDate;
        packEndDate = data?.endDate;
        pickUpLocation = data?.pickupLocation;
        startCity = data?.startCity;
        tripStatus = data?.tripStatus;
        paymentInfoStatus = data?.paymentInfo.status;
    } else {
        cardData = data;
    }
    const formData = [
        {
            label: 'Duration',
            answer: cardData?.quickView?.duration
        },
        {
            label: 'Organizer',
            answer: cardData?.organizerName
        }
    ];

    const bookingData = [
        {
            label: 'Trip Name',
            answer: cardData?.title || 'N/A'
        },
        {
            label: 'Booking Id',
            answer: data?._id || 'N/A'
        },
        {
            label: 'Start City',
            answer: data?.startCity
        },
        {
            label: 'Pickup Location',
            answer: data?.pickupLocation
        },
        {
            label: 'Trip Date',
            answer: standardDate(data?.startDate)
        },
        // Conditionally add Vehicle row
        ...(Array.isArray(data?.customTrip?.vehicle) && data.customTrip.vehicle.length > 0
            ? [
                  {
                      label: 'Vehicle',
                      answer: data.customTrip.vehicle.map((v) => `${v.vehicleName} - ${v.vehicleCount}`).join(', ')
                  },
                  {
                      label: 'Rooms',
                      answer: data?.customTrip?.rooms?.length
                  },
                  {
                      label: 'Extra Beds',
                      answer: data?.customTrip?.bed
                  }
              ]
            : [
                  ...(data.totalRooms > 0
                      ? [
                            {
                                label: 'Personal Room',
                                answer: data.totalRooms
                            }
                        ]
                      : [])
              ]),
        ...(data?.group === 'vehicle' && data.vehicle
            ? [
                  {
                      label: 'Vehicle',
                      answer: `Mode: ${data.vehicle.mode}
${data.vehicle.model ? `Model: ${data.vehicle.model}` : ''}${data.vehicle.model ? '\n' : ''}Empty Seats: ${data.vehicle.emptySeats}
Comfortable: ${data.vehicle.comfortable}`
                  }
              ]
            : []),
        ...(!data?.amountPaid?.isReserved && !data?.amountPaid?.isInstallment
            ? [
                  {
                      label: 'Total Amount',
                      answer: `₹${getHikedPrice(data?.amountPaid?.actual)}`
                  },
                  {
                      label: 'Discount',
                      answer: `₹${getHikedPrice(data?.amountPaid?.actual * 0.2)}`
                  },
                  {
                      label: 'Tax',
                      answer: `₹${data?.amountPaid?.tax || 0}`
                  },
                  {
                      label: 'Offer Amount',
                      answer: `₹${data?.amountPaid?.offerAmount || 0}`
                  }
              ]
            : []),
        {
            label: 'Amount Paid',
            answer: (
                <>
                    ₹{data?.amountPaid?.paid}
                    {data.isReserved || data?.amountPaid?.isReserved ? (
                        <div className='leftAmountDiv'>
                            Remaining amount to be paid on the trip Rs.
                            {data?.amountPaid?.total - data?.amountPaid.reserve * data.totalSeats} (including tax)
                        </div>
                    ) : null}
                </>
            )
        },

        {
            label: 'No. of Seats',
            answer: data?.userDetails?.length
        },
        {
            label: 'Organizer Name',
            answer: cardData?.organizerName
        }
    ];

    useEffect(() => {
        if (!data?.startDate) return;
        setIsTripMoreThanTenDays(isTripDateMoreThanNumOfDays(data.startDate, 10));
        setIsTripMoreThanOneDays(isTripDateMoreThanNumOfDays(data.startDate, 1));
    }, [data?.startDate]);

    return (
        <div className='tripStrap' onClick={() => handleClick(cardData._id)}>
            <div className='tripStrapContent'>
                <img
                    src={cardData?.cardImages?.length > 0 ? cardData?.cardImages[0] : image1}
                    alt='trvto_trip'
                    className='tripStrapImage'
                    loading='lazy'
                    decoding='async'
                />
                <div className='tripStrapInfoDiv'>
                    <div className='tripStrapNameDiv alignCenter'>
                        <div className='tripStrapInfo'>
                            <div className='tripStrapName'>
                                <span className={`${tripStatus === 'Cancelled' ? 'tripCancelled' : ''}`}>
                                    {truncateText(cardData?.title, width > 768 ? 50 : 25) || 'N/A'}
                                </span>
                                {Array.isArray(cardData?.quickView?.type) &&
                                    cardData.quickView.type.includes('Trek') && (
                                        <div className='typeInfo'>{cardData.quickView.type[0]}</div>
                                    )}
                                <Share onClick={(e) => share(e, cardData._id)} />
                                {tripStatus === 'Cancelled' && <p className='removeStrike  cancelled'>Cancelled</p>}
                            </div>
                            <p className='quickView'>
                                {/* {page === 'wishlist' && (
                                    <>
                                        {cardData?.quickView?.where +
                                            ' (' +
                                            (cardData?.days ? cardData.days + 'D/' + cardData?.nights + 'N' : 'N/A') +
                                            ')'}
                                        <span className='tripStartDate'>
                                            {' '}
                                            - {getFormattedDate(data?.tripDates)} Onwards
                                        </span>
                                    </>
                                )} */}
                                {page === 'bookings' && pickUpLocation}
                                {tripStatus !== 'Cancelled' && isTripMoreThanOneDays && (
                                    <button
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            sessionStorage.setItem(
                                                'confirmedBookingData',
                                                JSON.stringify({ ...data, isTripMoreThanOneDays })
                                            );
                                            navigate(`/trip/details/${cardData?._id}`);
                                        }}
                                        style={{
                                            marginLeft: 10,
                                            fontSize: '10px',
                                            border: 'none',
                                            cursor: 'pointer'
                                        }}
                                        className='typeInfo'
                                    >
                                        Update Pickup Location
                                    </button>
                                )}
                            </p>
                            <p>
                                {' '}
                                {tripStatus !== 'Cancelled' && isTripMoreThanOneDays && (
                                    <button
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            sessionStorage.setItem(
                                                'confirmedBookingData',
                                                JSON.stringify({ ...data, isTripMoreThanOneDays })
                                            );
                                            navigate(`/trip/details/${cardData?._id}`);
                                        }}
                                        style={{
                                            marginLeft: 10,
                                            fontSize: '10px',
                                            border: 'none',
                                            cursor: 'pointer'
                                        }}
                                        className='pickUp'
                                    >
                                        Update Pickup Location
                                    </button>
                                )}
                            </p>

                            <div className='tripCardNumInfo'>
                                <ReviewStars rating={cardData?.rating || data?.organizerId?.rating || 0} />
                                <span>{cardData?.rating || data?.organizerId?.rating || 0}</span>
                                <p style={{ margin: 0 }}>
                                    ({cardData?.reviewCount || data.organizerId.reviewCount || 0} Reviews)
                                </p>
                            </div>
                            {page === 'bookings' && (
                                <div className='tripStrapDateDetails'>
                                    <div className='alignCenter'>
                                        <img src={Calendar} width={24} height={24} alt='trvto_calendar' />
                                        <span className='innerStrap'>
                                            <span className='innerStrapColumn'>
                                                {page === 'bookings' && (
                                                    <span>{new Date(packStartDate).toLocaleDateString('en-GB')}</span>
                                                )}
                                                <span>{cardData?.quickView?.startTime.toUpperCase()}</span>
                                            </span>
                                            <label>-</label>
                                            <span className='innerStrapColumn'>
                                                {page === 'bookings' && (
                                                    <span>{new Date(packEndDate).toLocaleDateString('en-GB')}</span>
                                                )}
                                                <span>{cardData?.quickView?.endTime.toUpperCase()}</span>
                                            </span>
                                        </span>
                                    </div>

                                    {page === 'bookings' && (
                                        <>
                                            <div className='divider' />
                                            <div className='alignCenter'>
                                                <img src={UserCount} alt='trvto_user' />
                                                <span className='userCount'>{data?.totalSeats}</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                            {cardData?.type === 'rooms' && (
                                <div className='amenities'>{getAmenities(cardData?.quickView?.amenities)}</div>
                            )}
                            {page === 'bookings' &&
                                Array.isArray(cardData?.quickView?.type) &&
                                cardData.quickView.type.includes('Trek') && (
                                    <div className='innerFormContent'>
                                        <RenderFormContent data={formData} />
                                    </div>
                                )}
                        </div>
                        <div className='tripStrapPriceDiv'>
                            <div className='tripStrapPrDiv'>
                                <p
                                    className={`${
                                        tripStatus === 'Cancelled' ? 'tripStrapPrice tripCancelled' : 'tripStrapPrice'
                                    }`}
                                >
                                    <>
                                        ₹
                                        {page === 'bookings'
                                            ? data?.amountPaid?.paid
                                            : data?.datesType === 'fixed'
                                              ? cardData?.price[0]?.price.actual
                                              : Math.round(calculateOfferPrice(null, data, null))}
                                        {page !== 'bookings' && <span>/{typeSel === 'trip' ? 'person' : 'night'}</span>}
                                    </>
                                </p>
                                <div className='rateBtnCon'>
                                    {isRatingEnabled &&
                                        (tripStatus === 'Completed' || tripStatus === 'In Progress') && (
                                            <button
                                                onClick={(e) => openRatingModal(e, cardData)}
                                                className='rateButton'
                                            >
                                                Rate Now
                                            </button>
                                        )}
                                    {tripStatus === 'Cancelled' && (
                                        <p className='paymentStatus'>Payment Status: {paymentInfoStatus}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='moreIcons'>
                    {page === 'bookings' && tripStatus === 'Not Yet Started' && !isDisabled && (
                        <button className='cancelbtnTrip ' onClick={(e) => handleCancelBooking(e)}>
                            Cancel
                        </button>
                    )}
                    {page === 'bookings' && tripStatus === 'Not Yet Started' && isTripMoreThanTenDays && (
                        <button className='cancelBookingIcon' onClick={(e) => handleRescheduleBooking(e)}>
                            Reschedule
                        </button>
                    )}
                    {isRatingEnabled && (tripStatus === 'Completed' || tripStatus === 'In Progress') && (
                        <button onClick={(e) => openRatingModal(e, cardData)} className='cancelBookingIcon rateNowMob'>
                            Rate Now
                        </button>
                    )}
                    {page === 'bookings' && (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowBookingInfo(true);
                            }}
                            className='cancelBookingIcon bookingInfo'
                        >
                            Booking Info
                        </button>
                    )}
                    {page !== 'bookings' && (
                        <>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                className='cancelBookingIcon moreInfo bookingInfo deskView'
                            >
                                More
                                <span>{parsePurify(cardData?.overview)}</span>
                            </button>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleWishlistClick(cardData._id, userWishlist, typeSel, setUserWishlist);
                                }}
                                className='cancelBookingIcon deskView'
                            >
                                <Delete />
                            </button>
                        </>
                    )}
                    {showBookingInfo && (
                        <div
                            className='ratingModal bookingModal'
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowBookingInfo(false);
                            }}
                        >
                            <div className='modalHeader'>
                                Booking Info
                                <Close className='iconSize' />
                            </div>
                            <div className='modalContent'>
                                <TableContent data={bookingData} />
                            </div>
                        </div>
                    )}
                    {page !== 'bookings' && (
                        <div className='mobileOverview'>
                            <button
                                onClick={(e) => {
                                    handleInfoClick();
                                    e.stopPropagation();
                                }}
                                className='cancelBookingIcon bookingInfo'
                            >
                                More
                            </button>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleWishlistClick(cardData._id, userWishlist, typeSel, setUserWishlist);
                                }}
                                className='cancelBookingIcon'
                            >
                                <Delete />
                            </button>
                            {showOverlay && <div className='mobOverlay'>{parsePurify(cardData?.overview)}</div>}
                        </div>
                    )}
                </div>
            </div>
            <div>
                {cardData?.type === 'trip' && (
                    <>
                        <div className='tripDivider holidayDivider' />
                        <p className='locationInfo'>
                            Pickup Location: <span>{cardData?.quickView?.pickupLocation}</span>
                        </p>
                    </>
                )}
            </div>
            {showRescheduleModal && <RescheduleBooking setShowRescheduleModal={setShowRescheduleModal} data={data} />}
            {showModal && (
                <CancelBooking
                    setShowModal={setShowModal}
                    refundAmount={refundAmount.refAmount}
                    handleConfirm={(e) => {
                        e.stopPropagation();
                        handleBooking(data, setShowModal, typeSel)
                            .then(() => {
                                setRefetch((prev) => !prev);
                            })
                            .catch((err) => console.error('Cancel failed', err));
                    }}
                />
            )}
            {showRatingModal && (
                <div className='ratingModal'>
                    <div className='modalContent'>
                        <h3>Rate Your Trip</h3>
                        <RateTrip
                            props={{
                                popupRating,
                                setPopupRating,
                                comment,
                                setComment
                            }}
                        />
                        <div className='modalActions'>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeRatingModal(e);
                                }}
                                className='closeModal'
                            >
                                Cancel
                            </button>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeRatingModal(e);
                                    handleSubmitRating(e);
                                }}
                                className='submitRating'
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
